const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLMutation = require('app/graphql/Mutation');

const Modal = require('app/ui/Modal');
const ConfirmModal = require('app/ui/modal/Confirm');

const ProductEditModal = require('app/restaurant/analyse/product/EditModal');


const ExportPDFModal = require('app/restaurant/analyse/export/PDFModal');
const ExportExcelModal = require('app/restaurant/analyse/export/ExcelModal');


const ProductCreateModal = require('app/restaurant/analyse/product/CreateModal');
const ProductCreateForm = require('app/restaurant/analyse/product/Form');

class ListModal {
    defaultOptions() {
        return {
            'id': window.uniqid(),
            'title': "title",
            'analyse': null,
            'supplierIndex': null,
            'orderIndex': null,
            'productAssociations': [],
            'restaurant': null,

            'onNoData': function(){},
            'onClose': function(event){}
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onClickAddProduct = this.onClickAddProduct.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onClickExportPDF = this.onClickExportPDF.bind(this);
        this.onClickExportExcel = this.onClickExportExcel.bind(this);

        this.analyse = this.settings.analyse;
        if(!this.analyse.id){
            window.notify("Missing analyse object in ProductListModal","danger");
        }

        this.restaurant = this.settings.restaurant;
        this.supplierIndex = this.settings.supplierIndex;
        this.orderIndex = this.settings.orderIndex;

        this.invoice = null;
        this.productAssociations = null;

        this.hasModification = false;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.$content = $('<div/>')
        .addClass('restaurant-analyse-product-list-modal');

        this.modal = new Modal({
            'id': this.settings.id,
            'title': this.settings.title,
            'showFooter': false,
            'content' : this.$content,
            'modalSize': "max",
            'onClose': this.onClose,
        })
        this.modal.show();

        this.loadData();
    }

    isAllRequested(){
        let result = this.supplierIndex != null && this.orderIndex != null ? false : true;
        return result;
    }

    loadData(){
        var self = this;

        this.$content
        .html('')
        .append(window.App.generateLoader());

        let queries = [
            this.buildAnalyseQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.build(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildAnalyseQuery(){
        var self = this;

        let parameters = {
            'id': this.analyse.id,
        };

        let fields = [
            'id',
        ];

        if(this.isAllRequested()){

            fields.push('compiledProducts { product { id reference product { id reference quantity unit price supplier { name } } } productAssociations { id total price quantity orderedAt supplier { name } product { id reference unit quantity product { id reference quantity unit price supplier { id name } range { id name } } } } }');

            //fields.push('productAssociations { id total price quantity orderedAt supplier { name } product { id reference unit quantity product { id reference quantity unit price supplier { name } } } }')
        }else{
            fields.push('compiledData { supplier { id name } total orders { id date total productAssociations { id total price quantity orderedAt supplier { name } product { id reference unit quantity product { id reference quantity unit price supplier { id name } range { id name } } } } } }');
        }

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurantProspectAnalyse',
            'parameters': parameters,
            'fields': fields,
        });

        return query;
    }

    build(data){
        this.analyse = data.restaurantProspectAnalyse;
        this.productAssociations = null;

        if(this.isAllRequested()){
            this.productAssociations = this.analyse.compiledProducts;
        }else{
            let currentData = this.analyse.compiledData[this.supplierIndex];
            if(currentData){
                this.supplier = currentData['supplier'];
                let invoices = currentData['orders'];
                if(invoices){
                    this.invoice = currentData['orders'][this.orderIndex];
                    this.productAssociations = this.invoice.productAssociations;
                }
            }
        }

        if(!this.productAssociations){
            this.productAssociations = [];
        }

        this.$content.html('');
        if(this.productAssociations.length > 0){

            if(this.isAllRequested()){

                this.$btnExportPDF = $('<button/>')
                .attr("type",'button')
                .addClass("btn btn-danger btn-export-pdf")
                .append(
                    $('<i/>')
                    .addClass("fas fa-file-pdf")
                )
                .append(' ')
                .append(window.translate('app.restaurant.show.tabs.analyse.actions.exportPDF.label'))
                .on('click',this.onClickExportPDF);

                this.$btnExportExcel = $('<button/>')
                .attr("type",'button')
                .addClass("btn btn-success btn-export-excel")
                .append(
                    $('<i/>')
                    .addClass("fas fa-file-excel")
                )
                .append(' ')
                .append(window.translate('app.restaurant.show.tabs.analyse.actions.exportExcel.label'))
                .on('click',this.onClickExportExcel);

                this.$content
                .append(
                    $('<div/>')
                    .addClass('d-flex justify-content-center')
                    .append(this.$btnExportPDF)
                    .append('&nbsp;')
                    .append(this.$btnExportExcel)
                );

            }

            this.$content
            .append(this.buildTable());
        }else{

            this.settings.onNoData();
            this.$content
            .append(
                $('<div/>')
                .addClass('alert alert-danger')
                .append(window.translate('noData'))
            )
        }

        if(!this.isAllRequested()){

            this.$formContainer = $('<div/>')
            .addClass('product-create-form-container')
            .addClass('bg-light border-dark rounded p-4 mb-4')
            .append(
                $('<div/>')
                .addClass('d-flex justify-content-center')
                .append(
                    $('<i/>')
                    .addClass('fa fa-spin fa-spinner fa-2x')
                )
            );

            this.$content.prepend(this.$formContainer);
            this.buildCreateForm();
        }

    }

    buildCreateForm(){

        var self = this;

        let productAssociation = {
            'supplier': this.supplier.id,
            'orderedAt': this.invoice.date,
        };

        this.$formContainer.html('');
        this.form = new ProductCreateForm({
            'analyse': this.analyse,
            'productAssociation': productAssociation,
            'submitLabel': window.translate('app.restaurant.show.tabs.analyse.invoice.create.productAssociation.add.label'),
            'success': function(data){
                self.hasModification = true;
                self.refresh();
            },
            'onCancel': function(){
                self.buildCreateForm();
            }
        });

        this.$form = this.form.getForm();

        this.$formContainer.append(this.$form);
    }

    buildTable(){
        var self = this;

        let $table = $('<table/>')
        .addClass('table table-striped')
        .append(
            $('<thead/>')
            .append(
                $('<tr/>')
                .append(
                    $('<th/>')
                    .append(window.translate('restaurant.product.reference.label'))
                )
                .append(
                    $('<th/>')
                    .append(window.translate('restaurant.prospect.invoice.date.label'))
                )
                .append(
                    $('<th/>')
                    .append(window.translate('restaurant.prospect.product.supplier.label'))
                )
                .append(
                    $('<th/>')
                    .append(window.translate('restaurant.prospect.product.packaging.label'))
                )
                .append(
                    $('<th/>')
                    .append(window.translate('restaurant.prospect.invoice.quantity.label'))
                )
                .append(
                    $('<th/>')
                    .append(window.translate('restaurant.product.price.label'))
                )
                .append(
                    $('<th/>')
                    .append('')
                )
            )
        );

        let $tbody = $('<tbody/>')
        .appendTo($table);

        let productAssociationsOrdered = this.productAssociations.sort(function(a,b){

            let productA = a.product;
            let productB = b.product;
            let referenceA = productA.reference.toUpperCase();
            let referenceB = productB.reference.toUpperCase();

            let isALinked = (!productA.product || productA.product.id == 0) ? false : true;
            let isBLinked = (!productB.product || productB.product.id == 0) ? false : true;

            if(!isALinked && isBLinked){
                return -1;
            }
            if(!isBLinked && isALinked){
                return 1;
            }

            if (referenceA < referenceB) {
                return -1;
            }
            if (referenceA > referenceB) {
                return 1;
            }

            // names must be equal
            return 0;
        });

        for(var i in productAssociationsOrdered){
            let productAssociation  = productAssociationsOrdered[i];

            let product = productAssociation.product;

            let $reference = $('<div/>')
            .append(product.reference);


            let isLinked = (!product.product || product.product.id == 0) ? false : true;
            if(!isLinked){
                $reference.append(
                    $('<div/>')
                    .addClass('text-danger')
                    .append('('+window.translate('restaurant.prospect.product.unrelated.label')+')')
                );
            }else{
                let realProduct = product.product;
                let complement = realProduct.supplier.name 
                + ' - ' 
                + window.formatFloat(realProduct.quantity) + ' ' + realProduct.unit 
                + ' - ' 
                + window.translate('restofutePrice') 
                + ' : ' 
                + window.formatFloat(realProduct.price) 
                + ' &euro;'

                $reference.append(
                    $('<div/>')
                    .addClass('text-primary')
                    .append('('+complement+')')
                );
            }

            let $dateCell = $('<div/>');
            let $supplierCell = $('<div/>');
            let $packagingCell = $('<div/>');
            let $quantity = $('<div/>');
            let $priceCell = $('<div/>');
            let $actions = $('<div/>');


            if(this.isAllRequested()){
                let items = productAssociation.productAssociations;

                for(var i in items){
                    let item = items[i];
                    let supplierLabel = item.supplier.name;
                    let date = moment(item.orderedAt);
                    date = window.formatDate(date,window.translate('momentDateFormat.fullDay'));
                    let packaging =  window.formatFloat(item.product.quantity) + ' ' + item.product.unit;
                    let quantity = window.formatFloat(item.quantity);
                    let price = window.formatFloat(item.price) + "&euro;";

                    $dateCell.append(
                        $('<div/>')
                        .addClass('p-2')
                        .append(date)
                    );
                    $supplierCell.append(
                        $('<div/>')
                        .addClass('p-2')
                        .append(supplierLabel)
                    );
                    $packagingCell.append(
                        $('<div/>')
                        .addClass('p-2')
                        .append(packaging)
                    );
                    $quantity.append(
                        $('<div/>')
                        .addClass('p-2')
                        .append(quantity)
                    );
                    $priceCell.append(
                        $('<div/>')
                        .addClass('p-2')
                        .append(price)
                    );

                    let $btnEdit = $('<button/>')
                    .attr('type','button')
                    .addClass('btn btn-text text-primary')
                    .data('productAssociation',item)
                    .attr('title',window.translate('app.restaurant.show.tabs.analyse.invoice.product.edit.label'))
                    .append(
                        $('<i/>')
                        .addClass('fas fa-edit')
                    )
                    .on('click',function(event){
                        event.stopPropagation();
                        event.preventDefault();
                        let $btn = $(this);
                        self.onClickProductEdit($btn);
                    });

                    $actions.append(
                        $('<div/>')
                        .addClass('d-flex align-middle')
                        .append(
                            $btnEdit
                        )
                    );
                }

            }else{
                let date = moment(productAssociation.orderedAt);
                date = window.formatDate(date,window.translate('momentDateFormat.fullDay'));
                let packaging =  window.formatFloat(product.quantity) + ' ' + product.unit;
                let quantity = window.formatFloat(productAssociation.quantity);
                let price = window.formatFloat(productAssociation.price) + "&euro;";
                let supplierLabel = productAssociation.supplier.name;

                $dateCell.append(date)
                $supplierCell.append(supplierLabel)
                $packagingCell.append(packaging)
                $quantity.append(quantity)
                $priceCell.append(price)


                $actions = $('<ul/>')
                .addClass('list-inline btn-list-inline');

                let $btnEdit = $('<button/>')
                    .attr('type','button')
                    .addClass('btn btn-text text-primary')
                    .data('productAssociation',productAssociation)
                    .attr('title',window.translate('app.restaurant.show.tabs.analyse.invoice.product.edit.label'))
                    .append(
                        $('<i/>')
                        .addClass('fas fa-edit')
                    )
                    .on('click',function(event){
                        event.stopPropagation();
                        event.preventDefault();
                        let $btn = $(this);
                        self.onClickProductEdit($btn);
                    });

                let $btnDelete = $('<button/>')
                .attr('type','button')
                .addClass('btn btn-text text-danger')
                .data('productAssociation',productAssociation)
                .attr('title',window.translate('app.restaurant.show.tabs.analyse.invoice.product.delete.label'))
                .append(
                    $('<i/>')
                    .addClass('fas fa-trash')
                )
                .on('click',function(event){
                    event.stopPropagation();
                    event.preventDefault();
                    let $btn = $(this);
                    self.onClickProductDelete($btn);
                });

                $actions
                .append(
                    $('<li/>')
                    .addClass('list-inline-item')
                    .append($btnEdit)
                )
                .append(
                    $('<li/>')
                    .addClass('list-inline-item')
                    .append($btnDelete)
                );
            }



            let $row = $('<tr/>')
            .addClass('product-line');
            $row
            .append(
                $('<td/>')
                .append($reference)
            )
            .append(
                $('<td/>')
                .append($dateCell)
            )
            .append(
                $('<td/>')
                .append($supplierCell)
            )
            .append(
                $('<td/>')
                .append($packagingCell)
            )
            .append(
                $('<td/>')
                .append($quantity)
            )
            .append(
                $('<td/>')
                .append($priceCell)
            )
            .append(
                $('<td/>')
                .append($actions)
            )

            $tbody.append($row);

        }
        return $table;
    }

    close(){
        this.modal.dispose();
    }

    refresh(){
        this.loadData();
    }

    onClickProductEdit($btn){
        var self = this;
        let productAssociation = $btn.data('productAssociation');

        let title = productAssociation.product.reference;

        this.editModal = new ProductEditModal({
            'title': title,
            'analyse': this.analyse,
            'invoice': this.invoice,
            'productAssociation': productAssociation,
            'onClose': function(event){
                self.modal.show();
            },
            'onSuccess': function(productAssociation){
                self.hasModification = true;
                self.modal.show();
                self.refresh();
            }
        });
        this.modal.hide();
    }

    onClickProductDelete($btn){
        var self = this;
        let productAssociation = $btn.data('productAssociation');

        this.modal.hide();
        let confirmModal = new ConfirmModal({
            'messageContent': window.translate('app.restaurant.show.tabs.analyse.invoice.product.delete.confirm'),
            'btnConfirmClass': 'btn btn-danger btn-confirm',
            'btnCancelClass': 'btn btn-text text-secondary btn-cancel',
            'onConfirm': function(event,modal){
                self.proceedDeleteProductDelete(productAssociation,modal)
            },
            'onCancel': function(event,modal){
                self.modal.show();
            }
        })
        confirmModal.show();
    }

    proceedDeleteProductDelete(productAssociation,confirmModal){
        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'id': {
                'value': productAssociation.id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "DeleteRestaurantProspectAnalyseProductAssociation",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                confirmModal.dispose();
                self.modal.show();
                self.onProductDeleteSucceed(data);
            },
            'error': function(message, xhr){
                confirmModal.dispose();
                self.modal.show();
                self.onProductDeleteFailed(message,xhr);
            },
            'after': function(){
                //do nothing
            }
        });
        mutation.execute();
    }

    onProductDeleteSucceed(data){

        window.notify(data.message,"success");
        this.hasModification = true;

        this.refresh();
    }

    onProductDeleteFailed(message,xhr){
        window.notify(message,"error");
    }


    onClose(event){
        if(this.hasModification){
            this.settings.onClose(event);
        }
    }

    onClickAddProduct(event){
        var self = this;

        let title = window.translate('app.restaurant.show.tabs.analyse.invoice.create.productAssociation.add.label');

        let productAssociation = {
            'supplier': this.supplier.id,
            'orderedAt': this.invoice.date,
        }

        this.editModal = new ProductCreateModal({
            'title': title,
            'analyse': this.analyse,
            'invoice': this.invoice,
            'productAssociation': productAssociation,
            'onClose': function(event){
                self.modal.show();
            },
            'onSuccess': function(productAssociation){
                self.hasModification = true;
                self.modal.show();
                self.refresh();
            }
        });
        this.modal.hide();
    }

    onClickExportExcel(event){
        var self = this;
        let modal = new ExportExcelModal({
            'mutation': 'ExportAnalysisRestaurantProducts',
            'restaurant': this.restaurant,
            'onClose': function(event){
                self.modal.show();
            },
        });
        this.modal.hide();
    }

    onClickExportPDF(event){
        var self = this;
        let modal = new ExportPDFModal({
            'mutation': 'ExportAnalysisRestaurantProducts',
            'restaurant': this.restaurant,
            'onClose': function(event){
                self.modal.show();
            },
        });
        this.modal.hide();
    }
}

module.exports = ListModal;

